import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to clear admin policy settings tab state when navigating away from policy settings page
 */
export const useAdminPolicySettingsTabCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    const isPolicySettingsPage = location.pathname === '/administration/policy';
    if (!isPolicySettingsPage) {
      localStorage.removeItem('admin_policy_settings_tab');
    }
  }, [location.pathname]);
};

